export const PAYROC_COLLECT_JS_SRC =
  "https://retrieveronline.transactiongateway.com/token/Collect.js";

export const normalizePayrocTokenizationKey = (value?: string | null) => {
  const normalized = value?.trim();
  return normalized ? normalized : null;
};

export const loadCollectJsScript = (
  tokenizationKey: string,
  onLoad: () => void,
) => {
  const selector = `script[src="${PAYROC_COLLECT_JS_SRC}"]`;
  const existingScript = document.querySelector(selector) as HTMLScriptElement | null;
  const collectWindow = window as Window & { CollectJS?: unknown };

  if (
    existingScript &&
    existingScript.getAttribute("data-tokenization-key") === tokenizationKey
  ) {
    if (collectWindow.CollectJS) {
      onLoad();
      return () => undefined;
    }

    existingScript.addEventListener("load", onLoad, { once: true });
    return () => existingScript.removeEventListener("load", onLoad);
  }

  if (existingScript) {
    existingScript.remove();
  }

  const script = document.createElement("script");
  script.async = false;
  script.src = PAYROC_COLLECT_JS_SRC;
  script.setAttribute("data-tokenization-key", tokenizationKey);
  script.addEventListener("load", onLoad, { once: true });
  document.head.appendChild(script);

  return () => script.removeEventListener("load", onLoad);
};